
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25.892 32.9c1.8 1.1 3.5 2.3 5.3 3.4.8.5 1.2-2.5.4-3-1.5-1-3-2-4.6-3 .3-2 .7-4 1-6 .2-1.4-1-2.9-1.3-.8l-1.2 7.5c-.2.5-.1 1.5.4 1.9z"}}),_c('path',{attrs:{"d":"M54.191 40.3c-1.9-7.1-3.7-14.2-5.6-21.3 0-.5-.2-1-.7-1h-37.1c-.4 0-.6.5-.6.8-1.4 7.2-2.8 14.4-4.1 21.5-.1.5-.3 2.4.6 2.4h37.2c.1 0 .1 0 .2-.1.1 0 .2-.1.3-.3.1-.3.2-.7.2-1.1 1.1-6 2.3-12.1 3.4-18.2 1.4 5.5 2.9 11 4.3 16.5h-2.7c-1 0-1 3.1 0 3.1h3.9c.9.1.8-1.8.7-2.3zm-42.9-19.4c.1-.1.1-.1 0 0zm-1 5.1c.2-1.3.7-2.7.7-4 0-.4.1-.7.2-.9 1.2-.2 2.8 0 3.9 0h31.7c-1.2 6.1-2.3 12.3-3.5 18.4h-35.7c1-4.5 1.8-9 2.7-13.5z"}})])
          )
        }
      }
    